import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class ResetPasswordService extends Mutation {
  document = gql`
    mutation ResetPassword ($loginInput: LoginInput!) {
        resetPassword(loginInput: $loginInput)
    }
    `;

  }
